import SelectItem from '@/common/interfaces/SelectItem';
import { Module, ActionTree, Store, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { GetItineraries, GetDates } from './TeamExpeditionFinderModule.api';
import { registerSubModule } from '@/utils/vueUtils';
import { TeamExpeditionFinderModuleViewModel } from './TeamExpeditionFinderModule.types';
import { showToastMessage } from '@/utils/toastUtils';
import ToastType from '../../common/interfaces/enums/ToastType';

export interface TeamExpeditionFinderState {
  DestinationId: number;
  ItineraryId: number;
  DateId: number;
  Itinararies: SelectItem[];
  Dates: SelectItem[];
  DropdownStage: number;
}

export const GET_ITINERARIES_REQUEST = 'GET_ITINERARIES_REQUEST';
export const GET_ITINERARIES_SUCCESS = 'GET_ITINERARIES_SUCCESS';
export const GET_ITINERARIES_ERROR = 'GET_ITINERARIES_ERROR';

export const GET_DATES_REQUEST = 'GET_DATES_REQUEST';
export const GET_DATES_SUCCESS = 'GET_DATES_SUCCESS';
export const GET_DATES_ERROR = 'GET_DATES_ERROR';

export const SET_CURRENT_DESTINATION = 'SET_CURRENT_DESTINATION';
export const SET_CURRENT_ITINERARY = 'SET_CURRENT_ITINERARY';
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_STAGE = 'SET_STAGE';

const actions: ActionTree<TeamExpeditionFinderState, RootState> = {
  async [GET_ITINERARIES_REQUEST]({ state, commit }, destinationId: number) {
    try {
      const result = await GetItineraries(destinationId);
      commit(SET_CURRENT_DESTINATION, destinationId);
      commit(SET_CURRENT_DATE, null);
      commit(SET_CURRENT_ITINERARY, null);
      commit(SET_STAGE, 1);
      if (result && result.length > 0) {
        commit(GET_ITINERARIES_SUCCESS, result);
      } else {
        commit(GET_ITINERARIES_ERROR, "Didn't find any Itineraries.");
      }
    } catch (error) {
      commit(GET_ITINERARIES_ERROR, error);
    }
  },
  async [GET_DATES_REQUEST]({ state, commit }, itineraryId: number) {
    try {
      const result = await GetDates(itineraryId);
      commit(SET_CURRENT_ITINERARY, itineraryId);
      commit(SET_STAGE, 2);
      if (result && result.length > 0) {
        commit(GET_DATES_SUCCESS, result);
      } else {
        commit(GET_DATES_ERROR, "Didn't find any dates.");
      }
    } catch (error) {
      commit(GET_DATES_ERROR, error);
    }
  },
};

const mutations: MutationTree<TeamExpeditionFinderState> = {
  [GET_ITINERARIES_ERROR](state, message) {
    showToastMessage([
      {
        Text: message,
        Type: ToastType.Warning,
      },
    ]);
  },
  [GET_DATES_ERROR](state, message) {
    showToastMessage([
      {
        Text: message,
        Type: ToastType.Warning,
      },
    ]);
  },
  [GET_ITINERARIES_SUCCESS](state, payload: SelectItem[]) {
    state.Itinararies = payload;
  },
  [GET_DATES_SUCCESS](state, payload: SelectItem[]) {
    state.Dates = payload;
  },
  [SET_CURRENT_DATE](state, payload: number) {
    if (payload == null) state.Dates = [];
    state.DateId = payload;
  },
  [SET_CURRENT_ITINERARY](state, payload: number) {
    state.ItineraryId = payload;
  },
  [SET_CURRENT_DESTINATION](state, payload: number) {
    state.DestinationId = payload;
  },
  [SET_STAGE](state, payload: number) {
    state.DropdownStage = payload;
  },
  [CLEAR_FILTERS](state) {
    state.DestinationId = null;
    state.ItineraryId = null;
    state.DateId = null;

    state.Itinararies = [];
    state.Dates = [];
    state.DropdownStage = 0;
  },
};

const getters: GetterTree<TeamExpeditionFinderState, RootState> = {};

const registerModule = registerSubModule<
  TeamExpeditionFinderState,
  TeamExpeditionFinderModuleViewModel
>((data: TeamExpeditionFinderModuleViewModel) => {
  return {
    namespaced: true,
    state: {
      Itinararies: [],
      Dates: [],
      DestinationId: null,
      ItineraryId: null,
      DateId: null,
      DropdownStage: 0,
    },
    actions,
    mutations,
    getters,
  } as Module<TeamExpeditionFinderState, RootState>;
}, 'TeamExpeditionFinderModule');

export default async (store: Store<RootState>, data: TeamExpeditionFinderModuleViewModel) => {
  return registerModule(store, data);
};
